import { useApplicationSettings } from 'framework/uiTheme';
import { getCapitalizedString } from 'framework/utils';

const usePageTitle = () => {
  const { defaultPageTitle } = useApplicationSettings();

  const setPageTitle = (title: string) => {
    document.title = `${title ? `${getCapitalizedString(title)} - ` : ''}${defaultPageTitle}`;
  };

  const mapHtmlElementsForPageTitle = (elements = []) =>
    elements.reduce((sum, item: any) => `${item.textContent}${sum ? ` - ${sum}` : ''}`, '');

  return {
    mapHtmlElementsForPageTitle,
    setPageTitle,
  };
};

export default usePageTitle;
